import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "card mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "自治体情報", -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { id: "municipalityPath" }
const _hoisted_6 = { class: "card mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "ユーザー情報", -1)
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "updatePassword"
}, "パスワードを変更する。", -1)
const _hoisted_10 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_11 = { class: "row m-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-3" }, [
  /*#__PURE__*/_createTextVNode("現在のパスワード"),
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-danger required" }, "必須")
], -1)
const _hoisted_13 = { class: "row m-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-3" }, [
  /*#__PURE__*/_createTextVNode("新規のパスワード"),
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-danger required" }, "必須")
], -1)
const _hoisted_15 = {
  key: 0,
  class: "card mb-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "管理者情報", -1)
const _hoisted_17 = { class: "card-body" }

import { computed, reactive, ref, unref } from 'vue'
import { User, Municipality, AccountStatusType } from '@/plugins/nicotto'
import FormGroup from "@/components/ui/FormGroup.vue"
import InputUrl from "@/components/ui/InputUrl.vue"
import InputPref from "@/components/ui/InputPref.vue"
import InputText from "@/components/ui/InputText.vue"
import InputEmail from "@/components/ui/InputEmail.vue"
import InputTel from "@/components/ui/InputTel.vue"
import InputTextArea from "@/components/ui/InputTextArea.vue";
import { useValidateForm } from "@/components/ui/validator";
import InputUserStatus from "@/components/ui/InputUserStatus.vue";
import InputPassword from "@/components/ui/InputPassword.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPage',
  props: {
    user: null,
    municipality: null,
    status: { default: null },
    isAdmin: { type: Boolean, default: false },
    updatePassword: { type: Boolean }
  },
  emits: ["update:user", "update:municipality", "update:status", "update:updatePassword", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:user', user: User): void,
  (event: 'update:municipality', municipality: Municipality): void,
  (event: 'update:status', status: AccountStatusType|null): void,
  (event: 'update:updatePassword', updatePassword: boolean): void,
  (event: 'submit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { user: User, municipality: Municipality, status: AccountStatusType|null, isAdmin: boolean, updatePassword: boolean }



// eslint-disable-next-line func-call-spacing


const userKeys: (keyof User)[] = ['name', 'email', 'tel', 'department', 'municipality', 'enabled', 'current_password', 'new_password']
const municipalityKeys: (keyof Municipality)[] = ['name', 'prefecture', 'url', 'corporateNumber', 'code', 'note', 'path']
const user = reactive<any>({})
const municipality = reactive<any>({})
const status = computed({
  get: () => props.status,
  set: (val: AccountStatusType|null) => (emit('update:status', val))
})

userKeys.forEach(key => {
  user[key] = computed({
    get() {
      return props.user[key]
    },
    set(val) {
      const user = props.user.copy()
      user[key] = val
      emit('update:user', user)
    }
  })
})
municipalityKeys.forEach(key => {
  municipality[key] = computed({
    get() {
      return typeof props.municipality === 'undefined' ? '' : props.municipality[key]
    },
    set(val) {
      const municipality = props.municipality
      municipality[key] = val
      emit('update:municipality', municipality)
    }
  })
})
const updatePassword = computed({
  get: () => props.updatePassword,
  set: (val: boolean) => (emit('update:updatePassword', val))
})

const form = ref<HTMLFormElement|null>(null)
const submit = () => {
  if (! useValidateForm(unref(form) as unknown as HTMLFormElement).isValid()) {
    return
  }
  emit('submit')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submit, ["prevent"]),
    ref_key: "form",
    ref: form,
    novalidate: ""
  }, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(FormGroup, {
          label: "都道府県",
          required: true,
          class: "border-bottom-0",
          "label-for": "prefecture"
        }, {
          default: _withCtx(() => [
            _createVNode(InputPref, {
              id: "prefecture",
              modelValue: municipality.prefecture,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((municipality.prefecture) = $event)),
              label: "都道府県",
              required: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormGroup, {
          label: "自治体名",
          required: true,
          class: "border-bottom-0",
          "label-for": "municipalityName"
        }, {
          default: _withCtx(() => [
            _createVNode(InputText, {
              id: "municipalityName",
              modelValue: municipality.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((municipality.name) = $event)),
              label: "自治体名",
              required: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormGroup, {
          label: "自治体名(URL用)",
          class: "border-bottom-0",
          "label-for": "municipalityPath"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(municipality.path), 1)
          ]),
          _: 1
        }),
        _createVNode(FormGroup, {
          label: "ホームページURL",
          class: "border-bottom-0",
          "label-for": "municipalityUrl"
        }, {
          default: _withCtx(() => [
            _createVNode(InputUrl, {
              id: "municipalityUrl",
              modelValue: municipality.url,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((municipality.url) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(FormGroup, {
          label: "部署名",
          required: true,
          class: "border-bottom-0",
          "label-for": "department"
        }, {
          default: _withCtx(() => [
            _createVNode(InputText, {
              id: "department",
              modelValue: user.department,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.department) = $event)),
              label: "部署名",
              required: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormGroup, {
          label: "担当者名",
          required: true,
          class: "border-bottom-0",
          "label-for": "userName"
        }, {
          default: _withCtx(() => [
            _createVNode(InputText, {
              id: "userName",
              modelValue: user.name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.name) = $event)),
              label: "担当者名",
              required: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormGroup, {
          label: "電話番号",
          required: true,
          class: "border-bottom-0",
          "label-for": "userTel"
        }, {
          default: _withCtx(() => [
            _createVNode(InputTel, {
              id: "userTel",
              modelValue: user.tel,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.tel) = $event)),
              required: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormGroup, {
          label: "メールアドレス",
          required: true,
          class: "border-bottom-0",
          "label-for": "email"
        }, {
          default: _withCtx(() => [
            _createVNode(InputEmail, {
              id: "email",
              modelValue: user.email,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((user.email) = $event)),
              label: "メールアドレス",
              required: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (!__props.isAdmin)
          ? (_openBlock(), _createBlock(FormGroup, {
              key: 0,
              label: "パスワードの変更",
              class: "border-bottom-0"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(updatePassword) ? (updatePassword).value = $event : null)),
                  class: "form-check-input me-2",
                  type: "checkbox",
                  id: "updatePassword"
                }, null, 512), [
                  [_vModelCheckbox, _unref(updatePassword)]
                ]),
                _hoisted_9,
                (_unref(updatePassword))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(InputPassword, {
                          modelValue: user.current_password,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((user.current_password) = $event)),
                          class: "col",
                          autocomplete: "current-password",
                          required: _unref(updatePassword)
                        }, null, 8, ["modelValue", "required"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(InputPassword, {
                          modelValue: user.new_password,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((user.new_password) = $event)),
                          class: "col",
                          autocomplete: "new-password",
                          required: _unref(updatePassword)
                        }, null, 8, ["modelValue", "required"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.isAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createVNode(FormGroup, {
              label: "ユーザのステータス",
              class: "border-bottom-0",
              required: true,
              "label-for": "userStatus"
            }, {
              default: _withCtx(() => [
                _createVNode(InputUserStatus, {
                  id: "userStatus",
                  modelValue: _unref(status),
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(status) ? (status).value = $event : null)),
                  required: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(FormGroup, {
              label: "自治体名(URL用)",
              "label-for": "path",
              class: "border-bottom-0",
              required: _unref(status)=='enabled'
            }, {
              default: _withCtx(() => [
                _createVNode(InputText, {
                  label: "自治体名(URL用)",
                  id: "path",
                  pattern: "^[-_0-9A-Za-z]+$",
                  modelValue: municipality.path,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((municipality.path) = $event)),
                  required: _unref(status)=='enabled'
                }, null, 8, ["modelValue", "required"])
              ]),
              _: 1
            }, 8, ["required"]),
            _createVNode(FormGroup, {
              label: "法人番号",
              class: "border-bottom-0",
              "label-for": "corporate"
            }, {
              default: _withCtx(() => [
                _createVNode(InputText, {
                  label: "法人番号",
                  modelValue: municipality.corporateNumber,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((municipality.corporateNumber) = $event)),
                  id: "corporate"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(FormGroup, {
              label: "全国地方公共団体コード",
              class: "border-bottom-0",
              "label-for": "publicCode"
            }, {
              default: _withCtx(() => [
                _createVNode(InputText, {
                  label: "全国地方公共団体コード",
                  modelValue: municipality.code,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((municipality.code) = $event)),
                  id: "publicCode"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(FormGroup, {
              label: "備考",
              class: "border-bottom-0",
              "label-for": "note"
            }, {
              default: _withCtx(() => [
                _createVNode(InputTextArea, {
                  label: "備考",
                  modelValue: municipality.note,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((municipality.note) = $event)),
                  id: "note",
                  rows: 5
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})